import { render, staticRenderFns } from "./UserProfile.vue?vue&type=template&id=bef7d722&scoped=true"
import script from "./UserProfile.vue?vue&type=script&lang=js"
export * from "./UserProfile.vue?vue&type=script&lang=js"
import style0 from "./UserProfile.vue?vue&type=style&index=0&id=bef7d722&prod&lang=scss&scoped=true"
import style1 from "./UserProfile.vue?vue&type=style&index=1&id=bef7d722&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef7d722",
  null
  
)

export default component.exports